export const OKTA_CALLBACK_PATH = 'auth/login-callback';
